import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import AuthExperienceSelectors from '../selectors/experiences/Auth'

const useUserRole = () => {
  const profile = useSelector(AuthExperienceSelectors.profile)

  return useMemo(
    () => profile?.roleId || null,
    [profile?.roleId]
  )
}

export default useUserRole
